import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateTime } from 'luxon';
import { GeneralService } from '../../services/general/general.service';
@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: [
    '../../../shared-styles/dashboard.scss',
    './messages.component.scss',
  ],
})
export class MessagesComponent implements OnInit, OnDestroy {
  public isMobile: any;
  public headerHeight: any = 0;
  public loading: any = false;
  public subscriptions: any = [];
  public chatSelected: any = null;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef
  ) {
    this.isMobile = this.general.isMobile();
  }

  ngOnInit() {
    this.intializeSubscriptions();
    window.addEventListener('chat:open', this);
    window.dispatchEvent(new CustomEvent('hide:support'));
  }

  // Handle event Listener
  async handleEvent(event: any) {
    
    switch (event.type) {
      case 'chat:open':
        await this.openChat(event);
        break;
    }
  }

  ngOnDestroy() {
    window.removeEventListener('chat:open', this);
    window.dispatchEvent(new CustomEvent('show:support'));
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  /**
   * =================== Sidebar ===================
   */
  onGetHeight(height: any) {
    if (height) {
      this.headerHeight = height;
    }
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  openChat(event: any) {
    this.chatSelected = event.detail.id;
  }
}
